<template>
    <veui-dialog
        ui="medium"
        title="线索订阅"
        :open.sync="showSubClueModal"
        overlay-class="order-management-dialog"
        @cancel="cancleSub"
    >
        <veui-form
            ref="subForm"
            class="sub-form"
            :data="formData"
            :validators="validators"
        >
            <div class="sub-tip">订阅后匹配到符合的线索，将会根据您设定的接受时间进行短信通知，每日上限为20条。</div>
            <veui-field
                name="isSubscibe"
                label="开启订阅"
                searchable
            >
                <veui-switch
                    v-model="formData.is_subscibe"
                    ui="l"
                >
                </veui-switch>
            </veui-field>
            <veui-field
                name="receive_phone"
                label="接收号码"
                searchable
                :rules="[
                    {name: 'required', value: true, message: '请选输入手机号'},
                    {
                        name: 'pattern',
                        value: /^1\d{10}$/,
                        message: '不是正确的手机号',
                        triggers: 'blur',
                    },
                ]"
            >
                <veui-input
                    v-model="formData.receive_phone"
                    ui="l"
                    placeholder="请输入手机号"
                >
                </veui-input>
            </veui-field>
            <veui-field
                name="clue_territory"
                label="线索领域"
                searchable
                :rules="[{name: 'required', value: true, message: '请选择线索领域'}]"
            >
                <veui-select
                    v-model="formData.clue_territory"
                    ui="l"
                    data-stat-ignore
                    clearable
                    multiple
                    placeholder="请选择线索领域"
                    overlay-class="select-another-style"
                >
                    <veui-option
                        v-for="(item,index) in handleAreaOptions"
                        :key="index"
                        :value="item.value"
                        :label="item.text"
                    />
                </veui-select>
            </veui-field>
            <veui-field
                name="clue_city_code"
                label="线索地域"
                searchable
                :rules="[{name: 'required', value: true, message: '请选择线索地域'}]"
            >
                <veui-select
                    v-model="formData.clue_city_code"
                    ui="l"
                    data-stat-ignore
                    clearable
                    multiple
                    placeholder="请选择地域"
                    overlay-class="select-another-style"
                >
                    <veui-option-group
                        v-for="(item, index) in regionOption"
                        :key="index"
                        :label="item.label"
                        position="popup"
                        overlay-class="select-another-style"
                    >
                        <veui-option
                            :value="item.value + ''"
                            :label="item.label + '-不限'"
                        >不限</veui-option>
                        <veui-option
                            v-for="items in item.children"
                            :key="items.value"
                            :value="item.value + '$' + items.value"
                            :label="items.label"
                        />
                    </veui-option-group>
                </veui-select>
            </veui-field>
            <veui-field
                name="receive_week"
                label="接收日期"
                searchable
                :rules="[{name: 'required', value: true, message: '请选择接收日期'}]"
            >
                <veui-checkbox-group
                    v-model="formData.receive_week"
                    :items="flavors"
                >
                </veui-checkbox-group>
            </veui-field>
            <veui-fieldset
                label="接收时段"
                class="salary"
                tip="下限必须大于上限"
                :required="true"
            >
                <veui-field
                    field="receive_time_start"
                    name="receive_time_start"
                    :rules="numRequiredRule"
                >
                    <veui-time-picker
                        v-model="formData.receive_time_start"
                        mode="minute"
                        clearable
                    />
                </veui-field>
                <span class="time-space">至</span>
                <veui-field
                    :rules="numRequiredRule"
                    field="receive_time_end"
                    name="receive_time_end"
                >
                    <veui-time-picker
                        v-model="formData.receive_time_end"
                        mode="minute"
                        clearable
                    />
                </veui-field>
                <div class="time-tip" :class="{'time-tip-big': formSpaceBig}">
                    可以根据自身情况设置时间，如希望减少短信打扰，可以减少接受日期或缩短接受时间
                </div>
            </veui-fieldset>
            <div class="form-space" :class="{'form-space-big': formSpaceBig}"></div>
        </veui-form>
        <template #foot>
            <div class="foot-box">
                <veui-button
                    ui="l strong"
                    @click="cancleSub"
                >
                    取消
                </veui-button>
                <veui-button
                    :ui="isOk ? 'l primary' : 'l'"
                    @click="confirmSub"
                >
                    {{ phone || isEditEnd ? '修改' : '确认' }}
                </veui-button>
            </div>
        </template>
    </veui-dialog>
</template>
<script>

import {
    Form,
    Field,
    Button,
    Select,
    Input,
    CheckboxGroup,
    Dialog,
    Switch,
    TimePicker,
    Option,
    OptionGroup,
    Fieldset
} from 'veui';
import 'veui-theme-dls-icons';
import bendSDK from '@baidu/bend-plugin-sdk';
import isBoolean from 'lodash/isBoolean';
/**
 * @file sub
 * @author sunhemeng
 */
const url = {
    cityNext: '/bp/api/city/cityAll',
    vipcluesubscibe: 'law:/themis/law/commodity/VipClueSubscibe'
};

export default {
    components: {
        'veui-dialog': Dialog,
        'veui-button': Button,
        'veui-form': Form,
        'veui-field': Field,
        'veui-select': Select,
        'veui-option': Option,
        'veui-option-group': OptionGroup,
        'veui-time-picker': TimePicker,
        'veui-switch': Switch,
        'veui-input': Input,
        'veui-checkbox-group': CheckboxGroup,
        'veui-fieldset': Fieldset
    },
    props: {
        clueSubscibeInfo: {
            type: Object,
            default() {
                return {};
            }
        },
        areaOptions: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    computed: {
        isOk() {
            if (Object.keys(this.formData).length < 7) {
                return false;
            }
            if (this.clueSubscibeInfo && this.formData && this.formData.receive_phone
                && (JSON.stringify(this.formData) === JSON.stringify(this.clueSubscibeInfo))) {
                return false;
            }
            return (this.formData.receive_week && this.formData.receive_week.length
                && this.formData.clue_territory && this.formData.clue_territory.length
                && this.formData.clue_city_code && this.formData.clue_city_code.length
                && this.formData.receive_phone && this.formData.receive_time_end
                && this.formData.receive_time_start);
        },
        phone() {
            return this.clueSubscibeInfo && this.clueSubscibeInfo.receive_phone || '';
        },
        handleAreaOptions() {
            const areaOptions = this.areaOptions ? Array.from(this.areaOptions) : [];
            return areaOptions.filter(item => item.text && item.text.indexOf('全部') < 0);
        }
    },
    data() {
        return {
            isWorking: false,
            flavors: [
                {value: '1', label: '周一'},
                {value: '2', label: '周二'},
                {value: '3', label: '周三'},
                {value: '4', label: '周四'},
                {value: '5', label: '周五'},
                {value: '6', label: '周六'},
                {value: '7', label: '周日'}
            ],
            formData: {
                is_subscibe: false
            },
            showSubClueModal: false,
            countRule: [
                {
                    name: 'required',
                    value: true,
                    message: '请输入线索数量',
                    triggers: 'change'
                }
            ],
            regionOption: [],
            numRequiredRule: [
                {
                    name: 'required',
                    value: true,
                    triggers: 'blur'
                }
            ],
            formSpaceBig: false,
            validators: [
                {
                    fields: ['receive_time_start', 'receive_time_end'],
                    handler: (start, end) => {
                        if (start == null || end == null) {
                            return true;
                        }
                        let date = new Date();
                        let a = start.split(':');
                        let b = end.split(':');
                        return new Promise(resolve => {
                            let res = {};
                            if (
                                date.setHours(a[0], a[1]) > date.setHours(b[0], b[1])
                                || date.setHours(a[0], a[1]) === date.setHours(b[0], b[1])
                            ) {
                                res.receive_time_end = '后面时间必须大于前面时间';
                            }
                            if (res.receive_time_end) {
                                this.formSpaceBig = true;
                            }
                            else {
                                this.formSpaceBig = false;
                            }
                            resolve(Object.keys(res).length ? res : true);
                        });
                    },
                    triggers: ['change', 'submit']
                }
            ],
            isEditEnd: false
        };
    },
    methods: {
        cancleSub() {
            this.showSubClueModal = false;
            if (!this.isEditEnd) {
                this.formData = {...this.clueSubscibeInfo};
            }
        },
        confirmSub() {
            this.$refs.subForm.validate().then(flag => {
                if (isBoolean(flag) && flag) {
                    this.postData();
                }
                else {
                    const toast = {
                        content: '请完成必填选项',
                        duration: 3
                    };
                    this.$Message.info(toast);
                }
            });
            this.$log && this.$log.send({
                type: 'clk',
                value: 'confirm-sub'
            });
        },
        postData() {
            if (this.isWorking || !this.isOk) {
                return;
            }
            this.isWorking = true;
            const data = {
                ...this.formData,
                receive_week: this.formData.receive_week.join(','),
                clue_territory: this.formData.clue_territory.join(','),
                clue_city_code: this.formData.clue_city_code.join(','),
                is_subscibe: this.formData.is_subscibe ? 1 : 0
            };
            this.$http.post(url.vipcluesubscibe, {
                ...data,
                params: JSON.stringify(data)
            }).then(res => {
                const respData = res?.data?.data;
                if (respData.errno !== 0) {
                    this.$Message.info('订阅失败，请重试');
                }
                else {
                    this.$Message.success('订阅成功!');
                    this.showSubClueModal = false;
                    this.isEditEnd = true;
                    this.$log && this.$log.send({
                        type: 'clk',
                        value: 'confirm-sub-success'
                    });
                }
                this.isWorking = false;
            }).catch(() => {
                this.$Message.info('订阅失败，请重试');
                this.isWorking = false;
            });
        }
    },
    mounted() {
        this.$http.get(url.cityNext).then(res => {
            if (!res || +res.code !== 0) {
                return;
            }
            const respData = res?.data;
            respData && respData.map(item => {
                if (item.label && item.label.indexOf('市') >= 0) {
                    item.children = Array.from(item.children[0].children);
                }
                return item;
            });
            this.regionOption = respData;
            this.formData = {...this.clueSubscibeInfo};
        }).catch(() => {
        });
    },
    destroyed() {
    }
};
</script>
<style lang="less" scoped>
.sub-tip {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #333;
    margin: 10px 0 16px;
}

.time-tip {
    width: 100%;
    position: absolute;
    top: 100%;
    left: 0;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #999;
    line-height: 22px;
}

.time-tip-big {
    margin-top: 24px;
}

.form-space {
    width: 100%;
    height: 20px;
}

.form-space-big {
    width: 100%;
    height: 50px;
}

.sub-form {
    /deep/ .veui-field-label {
        text-align: left;
        margin-right: 0;
        width: 5.2em;
        display: flex;
        align-items: center;
    }

    /deep/ .veui-focus {
        box-shadow: none;
        border: 1px solid rgba(56, 85, 213, 1);
    }

    /deep/ .veui-input:hover {
        border: 1px solid rgba(56, 85, 213, 1);
    }

    /deep/ .veui-field {
        margin-bottom: 24px;
    }

    /deep/ .veui-select {
        width: 482px;
        min-height: 38px;
    }

    /deep/ .veui-tag-default {
        height: 28px;
        border: 1px solid rgba(233, 236, 243, 1) !important;
        border-radius: 14px;
        background: none;
    }

    /deep/ .veui-select-expanded .veui-input {
        border: 1px solid rgba(56, 85, 213, 1);
    }

    /deep/ .veui-input {
        width: 100%;
        height: auto !important;
        min-height: 38px;
    }

    /deep/ .veui-time-picker {
        width: 224px;
        height: 38px;
    }

    /deep/ .veui-checkbox-group-items {
        margin-left: 0;
    }

    /deep/ .veui-checkbox {
        margin-left: 0;
        margin-right: 15px;
    }

    /deep/ .veui-field-label::before {
        content: "";
        margin-right: 0;
    }

    /deep/ .veui-field-label::after {
        content: " *";
        margin-right: 2px;
        color: #cc1800;
    }
}

.salary {
    /deep/ .veui-field {
        margin-bottom: 0;
    }
}

.time-space {
    margin: 0 10px;
}

.foot-box {
    display: flex;
    justify-content: center;
}
</style>

<style lang="stylus">
.select-another-style .veui-select-options[ui~="l"]
    .veui-checkbox-box
        width: 0;
        height: 0;
        opacity: 0;
        margin-right: 0 !important;

    .veui-option-selected
        background: #f6f8f9;
    .veui-option-selected .veui-checkbox-label
        color: #3855d5;
        font-family: PingFangSC-Medium;
        font-size: 14px;

.veui-option-group-box .veui-option[ui~="l"]
    .veui-checkbox-box {
        width: 0;
        height: 0;
        opacity: 0;
        margin-right: 0 !important;
    }
.veui-option-group-box .veui-option-selected[ui~="l"]
    background: #f6f8f9;
    .veui-checkbox-label {
        color: #3855d5;
        font-family: PingFangSC-Medium;
        font-size: 14px;
    }
</style>

